import {Header} from 'components/Header/BasicHeader';
import {TOAST_CLOSE_TIME} from 'core/constants';
import {BottomBar} from 'modules/bottom-bar/components/BottomBar';
import {CatalogMenu} from 'modules/categories/components/CatalogMenu';
import {Footer} from 'modules/footer/components/Footer';
import {Modal} from 'modules/modals/components/Modal';
import {MODALS} from 'modules/modals/constants';
import {useOnlineChatConnect} from 'modules/online-chat/hooks/useOnlineChatConnect';
import React, {FC, ReactNode, useContext, useEffect} from 'react';
import {ToastContainer} from 'react-toastify';
import style from './style.module.scss';
import {Page} from 'components/Page';
import {ModalLazyLoader} from 'components/ModalLazyLoader';
import dynamic from 'next/dynamic';
import {useWishListNotification} from 'modules/wish-list/hooks/useWishListNotification';
import {isBrowserContext, isMobileByScreen} from 'core/helpers';
import {UpButton} from 'components/UpButton';
import {useScrollUpButton} from 'core/hooks/useScrollUpButton';
import classNames from 'classnames';
import {CommonLayoutContext} from 'layouts/CommonLayout/context';
import {CloseConfirmationDialog} from 'modules/auth/components/CloseConfirmationDialog';
import FlocktoryIdentity from 'components/flocktory/FlocktoryIdentity';
import {useGetAbExpressOrder} from 'modules/ab-tests/hooks';
import {AppModals} from 'modules/modals/components/AppModals';
import {ReservationModalProvider} from 'modules/product-snippet/providers/ReservationModalProvider';
import {useStockExtraLinksHidden} from 'modules/stock-x/hooks/useStockExtraLinksHidden';

const AuthDialog = dynamic(() => import('modules/auth/components/AuthDialog'), {
    loading: () => <ModalLazyLoader />,
});

// const ShieldModal = dynamic(() => import('modules/shields/components/ShieldModal'), {
//     loading: () => <ModalLazyLoader />,
// });

// const BonusesModal = dynamic(() => import('modules/price-n-bonuses/components/BonusesModal'), {
//     loading: () => <ModalLazyLoader />,
// });

// const StoreFindingModal = dynamic(() => import('modules/availability-delivery-pickups/components/StoreFindingModal'), {
//     loading: () => <ModalLazyLoader />,
// });

// const ChooseCityModal = dynamic(() => import('modules/locations/components/ChooseCityModal'), {
//     loading: () => <ModalLazyLoader />,
// });

export interface ILayoutProps {
    headerNoShadow?: false;
    isHeaderHidden?: boolean;
    isHeaderHiddenOnMobile?: boolean;
}

interface IProps extends ILayoutProps {
    children: ReactNode;
}

export const Layout: FC<IProps> = ({children, headerNoShadow = false, isHeaderHiddenOnMobile = false}) => {
    useEffect(() => {
        if (!isBrowserContext()) {
            return undefined;
        }
        try {
            if ('undefined' !== typeof window && window.history && 'scrollRestoration' in window.history) {
                const previous = window.history.scrollRestoration;
                window.history.scrollRestoration = 'manual';
                return () => {
                    try {
                        window.history.scrollRestoration = previous || 'auto';
                    } catch (e) {}
                };
            }
        } catch (e) {}
        return undefined;
    }, []);

    useWishListNotification();

    useOnlineChatConnect();

    const {isActive: isAbExpressOrder} = useGetAbExpressOrder();
    const isStockExtraLinksHidden = useStockExtraLinksHidden();

    const {isShowUpButton, handleClickUpButton} = useScrollUpButton();
    const {upButtonClassName} = useContext(CommonLayoutContext);

    return (
        <ReservationModalProvider>
            <Header headerNoShadow={headerNoShadow} isHiddenOnMobile={isHeaderHiddenOnMobile} />
            <main
                className={classNames(style.layoutContent, {
                    [style.layoutContentNew]: isAbExpressOrder,
                    [style.hiddenOnMobile]: isHeaderHiddenOnMobile,
                    [style.isExtraLinksHidden]: isStockExtraLinksHidden,
                })}
            >
                <Page>{children}</Page>
                {isShowUpButton && (
                    <UpButton
                        className={classNames(style.layoutUpButton, upButtonClassName)}
                        onClick={handleClickUpButton}
                    />
                )}
            </main>
            <Footer />
            <BottomBar profileType={'professional'} />
            <ToastContainer
                autoClose={TOAST_CLOSE_TIME}
                className={style.toastContainer}
                closeButton={false}
                closeOnClick={false}
                hideProgressBar={true}
                icon={false}
                position={isMobileByScreen() ? 'bottom-right' : 'top-right'}
            />
            <Modal hasPortal={false} willMount={false} disableOnPageLoading={false} name={MODALS.CATALOG_MENU.name}>
                <CatalogMenu />
            </Modal>
            <Modal
                disableOnPageLoading={false}
                confirmationModalName={MODALS.AUTH_CLOSE_CONFIRMATION.name}
                name={MODALS.AUTH_DIALOG.name}
                willMount={true}
            >
                <AuthDialog propagate={true} />
            </Modal>
            <Modal disableOnPageLoading={false} name={MODALS.AUTH_CLOSE_CONFIRMATION.name} willMount={true}>
                <CloseConfirmationDialog />
            </Modal>
            {/* <Modal hasPortal name={MODALS.SHIELD.name} willMount>*/}
            {/*    <ShieldModal />*/}
            {/* </Modal>*/}
            {/* <Modal name={MODALS.CITY_CHOOSE.name} willMount>*/}
            {/*    <ChooseCityModal />*/}
            {/* </Modal>*/}
            {/* <Modal hasPortal={true} name={MODALS.PRODUCT_PRICE.name} willMount>*/}
            {/*    <BonusesModal />*/}
            {/* </Modal>*/}
            {/* <Modal name={MODALS.PRODUCT_SHOP.name} willCloseOnUrlChange>*/}
            {/*    <StoreFindingModal />*/}
            {/* </Modal>*/}
            <AppModals />
            <FlocktoryIdentity />
        </ReservationModalProvider>
    );
};
